import { motion } from 'framer-motion';
import { SITE } from '@/constants/testIds';

export function Marquee() {
  const line = [
    'Premium Window Care',
    "Denver's Finest",
    'Spotless Views',
    'Residential & Commercial',
    'Streak-Free Guarantee',
  ];
  const track = [...line, ...line, ...line];

  return (
    <section
      data-testid={SITE.marqueeSection}
      className="relative bg-foreground text-background overflow-hidden py-24 lg:py-32"
    >
      <div className="whitespace-nowrap will-change-transform flex marquee-track">
        {track.map((t, i) => (
          <span
            key={i}
            className="font-serif italic lowercase font-light text-[10vw] leading-none px-8 flex items-center gap-8 text-background/95"
          >
            {t}
            <motion.span
              aria-hidden
              className="inline-block w-3 h-3 rounded-full bg-[hsl(var(--sage))] align-middle"
            />
          </span>
        ))}
      </div>
    </section>
  );
}
